module.exports = __webpack_public_path__ + "static/sport/bgi-swiper.ded8c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi-swiper.png
// module id = 4CZm
// module chunks = 0